<template>
    <div class="app-wrapper" :class="{ admin: isAdmin }">
        <AdminMenu v-if="isAdminLoggedin"/>
        <router-view />
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue"
import ServiceWorkerMixin from "./mixins/ServiceWorkerMixin"
import AdminMenu from "./components/admin/AdminMenu.vue"
import SocketHelper from "./utils/SocketHelper"

export default defineComponent({
    name: "App",

    components: {
        AdminMenu
    },

    mixins: [ServiceWorkerMixin],

    data() {
        return {
            isAdmin: false,
            isAdminLoggedin: false
        }
    },

    created() {
        // eslint-disable-next-line no-undef
        console.log("%cXPark version " + __APP_VERSION__, "color: white; background: #990000;padding : 2px;")

        this.initCentralSocketClient()
    },

    watch:   {
        "$router.currentRoute": {
            immediate: true,
            deep: true,
            handler() {
                const routes = this.$router.currentRoute.value?.matched
                if (routes.length === 1) {
                    this.isAdminLoggedin = routes[0].meta.requireLogin === true
                    this.isAdmin = this.isAdminLoggedin || routes[0].name === "admin-login"
                }
            }
        }
    },

    methods: {
        initCentralSocketClient() {
            const settings = (window as any)._settings
            const currentUrl = window.location.hostname
            const socketUrl = `http://${currentUrl}:${settings.socketPort}`
            SocketHelper.connect(socketUrl, SocketHelper.socketClient)
        }
    }
})
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}

.app-wrapper {
  width: 100%;
  height: 100%;
}
</style>
